export const getPromisifiedActionsResults = (state: any) => state.promisifiedActionsResults || {};
